// extracted by mini-css-extract-plugin
export default {"idBadge":"IdBadge_idBadge__3SDfi","idText":"IdBadge_idText__yKC8z"};